import React from 'react';
import Moment from 'react-moment';
import moment from 'moment';
import { withTranslation } from 'react-i18next';
import { getTimes } from '../models/times';
import { Alert } from "reactstrap";

class ZmanTevilah extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoaded: false,
      time: null
    };
  }

  componentDidMount() {
    this.intervalID = setInterval(
      () => this.refresh(),
      360000
    );
    this.retrieveZmanTevilah();
  }

  componentDidUpdate(prevProps){
    if(prevProps.date !== this.props.date || prevProps.zmanim !== this.props.zmanim){
      this.retrieveZmanTevilah();
    }
  }

  retrieveZmanTevilah() {
    const { zmanim } = this.props;
    if(zmanim){
      this.setState({
        isLoaded: true,
        time: zmanim.zmanTevillah,
        time2: zmanim.zmanTevillah2,
        time72: zmanim.zmanTevillah72,
      })
    } else{
      if(!this.props.date){
        localStorage.removeItem('zmanTevilah');
        localStorage.removeItem('zman2');
        localStorage.removeItem('zman72');
        let localStorageZmanim = JSON.parse(localStorage.getItem('zmanim'));
        let savedDate = localStorageZmanim && localStorageZmanim.savedTime ? moment(localStorageZmanim.savedTime) : null;
      
        if ( localStorageZmanim && localStorageZmanim.data && !moment().isAfter(savedDate,'hour') ) {
          this.setState({
            isLoaded: true,
            time: localStorageZmanim.data.zmanTevillah,
            time2: localStorageZmanim.data.zmanTevillah2,
            time72: localStorageZmanim.data.zmanTevillah72,
            shkia: localStorageZmanim.data.shkia
          })
          return false;
        }
      } else{
        this.setState({isLoaded: false})
      }
      getTimes(this.props.date||null)
        .then(
          result => {
            if(!this.props.date){
              localStorage.setItem('zmanim', JSON.stringify({savedTime: moment().format(), data: result }));
            }
            this.setState({
              isLoaded: true,
              time: result.zmanTevillah,
              time2: result.zmanTevillah2,
              time72: result.zmanTevillah72,
              shkia: result.shkia
            })
          }, error => {
            this.setState({error});
          }
        );
    }
  }

  componentWillUnmount() {
    clearInterval(this.intervalID);
  }

  refresh() {
    this.retrieveZmanTevilah();
  }

  render() {
    const { t, className, showShkia, settings, showFridayClosing, showCandleLighting } = this.props;
    const { isLoaded, time, time2, time72, shkia, error } = this.state;
    const fridayClosing = moment(shkia).subtract((settings&&settings.fridayPrepClosingMinutesBeforeShkia&&settings.fridayPrepClosingMinutesBeforeShkia.value),'minutes');
    const candleLighting = moment(shkia).subtract((settings&&settings.zmanCandleLightingMinutesBeforeShkia&&settings.zmanCandleLightingMinutesBeforeShkia.value),'minutes');
    return isLoaded ? (
      <>
      <div className={"zman-tevilah " + (className?className:"")}>
        {showFridayClosing && fridayClosing?
          <div className="zmanTime">
            <div className="title">{t('Closing')}:</div>
            <Moment format={t("h:mm")} element="span">{fridayClosing}</Moment>
          </div>
        :null}
        {showCandleLighting && candleLighting?
          <div className="zmanTime">
            <div className="title">{t('Candle Lighting')}:</div>
            <Moment format={t("h:mm")} element="span">{candleLighting}</Moment>
          </div>
        :null}
        {showShkia && shkia?
          <div className="zmanTime">
            <div className="title">{t('Shkia')}:</div>
            <Moment format={t("h:mm")} element="span">{shkia}</Moment>
          </div>
        :null}
        <div className="title">{t('Zman')}:</div>
        <div className="zmanTime">
          {time2||time72?<div className="zmanTitle">{t('standardZman')}</div>:null}
          <Moment format={t("h:mm")} element="span">{time}</Moment>
        </div>
        {time2?
          <div className="zmanTime">
            <div className="zmanTitle">{t('belzZman')}</div>
            <Moment format={t("h:mm")} element="span">{time2}</Moment>
          </div>
        :null}
        {time72?
          <div className="zmanTime">
            <div className="zmanTitle">{t('rtZman')}</div>
            <Moment format={t("h:mm")} element="span">{time72}</Moment>
          </div>
        :null}
      </div>
      </>
    ) : 
    error?
      <Alert color="danger">{t(error)}</Alert>
    :null;
  }
}

export default withTranslation()(ZmanTevilah);